/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Create_DescriptionInputs */

const en_admin_roles_create_description = /** @type {(inputs: Admin_Roles_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define a new system role`)
};

/**
* | output |
* | --- |
* | "Define a new system role" |
*
* @param {Admin_Roles_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_create_description = /** @type {((inputs?: Admin_Roles_Create_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Create_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_create_description(inputs)
});
export { admin_roles_create_description as "admin.roles.create_description" }